export default __webpack_public_path__ + "static/media/BCI.c05107d2.svg";